// @flow

import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import Menu from "../Menu";
import RoofHeader from "./RoofHeader";
import FoundationHeader from "./FoundationHeader";
import SvgMapperFound from "../SvgMapperFound";
import "./Header.scss";

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false
    };
  }

  showMenu(event) {
    console.log("showe menu", this.state.active);
    event.preventDefault();
    this.setState({
      active: true
    });
  }
  toggleMenu() {
    this.setState({
      active: !this.state.active
    });
  }

  closeMenu() {
    this.setState({
      active: false
    });
  }

  render() {
    if (this.props.type == "foundation-header") {
      return <FoundationHeader />;
    } else if (this.props.type == "roof-header") {
      return <RoofHeader />;
    } else {
      return (
        <React.Fragment>
 <div>
            <header id="roof-main" className="main-header">
              <div className="header row ">
                <div className="col-6 header-left__col">
                  <div className="header-left__container">
                    <img
                      className="evomer-logo"
                      src="/img/evomer-logo-szybciej.svg"
                      alt="Evomer logo"
                    ></img>
                  </div>
                </div>
                <div className="col-6 header-right__col">
                  <div className="header-right__container">
                    <img src="/img/tytan-logo.svg"></img>
                  </div>
                  <span
                    onClick={this.showMenu.bind(this)}
                    className="af-icon-menu red-burger"
                  ></span>
                </div>
              </div>
            </header>
            <Menu
              menu={this.state.active}
              closeMenu={this.closeMenu.bind(this)}
              activeLink={this.props.activeLink}
            />
          </div>
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js